import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("このサイトについて")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("利用規約")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("プライバシーポリシー")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f7_view = _resolveComponent("f7-view")!
  const _component_f7_link = _resolveComponent("f7-link")!
  const _component_f7_toolbar = _resolveComponent("f7-toolbar")!
  const _component_f7_page = _resolveComponent("f7-page")!

  return (_openBlock(), _createBlock(_component_f7_page, { style: {"background-color":"#FFF"} }, {
    default: _withCtx(() => [
      _createVNode(_component_f7_view, {
        url: "/:token/registration/detail/",
        style: {"padding-bottom":"0px"}
      }),
      _createVNode(_component_f7_toolbar, {
        tabbar: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_f7_link, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_f7_link, null, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_f7_link, null, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}